import {useActions, useGetters, useMutators, useState} from './_default';
export default {
    namespaced: true,
    state: {
        permissions: {},
    },
    getters: {
        get(state) {
            return (name) => !!state.permissions[name];
        },

        isAdmin(state) {
            return !!state.permissions.is_admin;
        },

        canChangeAppearance(state) {
            return !!state.permissions.change_appearance;
        },

        has(state) {
            return (name) => typeof state.permissions[name] !== 'undefined';
        }
    },
    mutations: {
        set(state, permissions) {
            state.permissions = permissions;
        },

        update(state, permissions) {
            Object.assign(state.permissions, permissions);
        }
    },
    actions: {
        ...useActions(),
    },
}
